import { wxShare } from '@/api/resetApi.js'

const state = {
  getChildData:[],
  checkList:[],
}

const mutations = {
  // 同步方法
  changeNum(state,data) {}

}

const actions = {
  // 微信分享
  async wxshare({ commit, state }) {
    let res = await wxShare()
    // console.log('res11111111=',res)
    try {
      if (res.data.code === 200) {
        const { data } = res
        return data
      }
    } catch (error) {
      console.log(error)
    }
  },
  // 异步方法名称
  async demandInfo({ commit, state }) {}
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
